import { AvatarImage } from "@/components/ui/avatar";
import { useAuthenticatedMediaUrl } from "@/hooks/useAuthenticatedMedia";
import { useState } from "react";
import { imageRequestWidth, sizedCdnImage } from "@/lib/cdnImage";

interface AuthenticatedAvatarImageProps {
  src?: string | null;
  alt?: string;
  onImageLoaded?: (url: string | null) => void;
  size?: number;
}

export function AuthenticatedAvatarImage(props: AuthenticatedAvatarImageProps) {
  return <AvatarImageSource key={props.src} {...props} />;
}

function AvatarImageSource({
  src,
  alt,
  onImageLoaded,
  size,
}: AuthenticatedAvatarImageProps) {
  const resolvedSrc = useAuthenticatedMediaUrl(src ?? undefined);
  const [useOriginal, setUseOriginal] = useState(false);
  if (!resolvedSrc) {
    onImageLoaded?.(null);
    return null;
  }
  onImageLoaded?.(resolvedSrc);
  const variant = size ? sizedCdnImage(resolvedSrc, imageRequestWidth(
    size, typeof window === "undefined" ? 1 : window.devicePixelRatio,
  )) : resolvedSrc;
  return (
    <AvatarImage
      src={useOriginal ? resolvedSrc : variant}
      alt={alt}
      onLoadingStatusChange={(status) => {
        if (status === "error" && variant !== resolvedSrc && !useOriginal) {
          setUseOriginal(true);
        }
      }}
    />
  );
}
